import one from "../assets/png/Projects/restro.png";
import two from "../assets/png/Projects/gpt3.png";
import three from "../assets/png/Projects/nike.png";
import four from "../assets/png/Projects/imdb.png";


export const projectsData = [
  {
    id: 1,
    projectName: "restaurant_app",
    // projectHade: "gricht-restro-app",
    projectDesc: [
      "Hello! Gericht Restaurant App is a single page website which resemble the landing page of a resturant. Built using the react.js and CSS3. The webpage is fully responsive and delivers better UI."
    ],
    tags: ["HTML", "CSS", "JavaScript","React"],
    code: "https://github.com/pri65/restraurant_app",
    demo: "https://gericht-restro-app.netlify.app/",
    image: one,
  },

  {
    id: 2,
    projectName: "GPT-3",
    // projectHade: "gricht-restro-app",
    projectDesc: [
      "GPT-3 is a neural network machine learning model trained using internet data to generate any type of text.It is fully responsive website with modern UI/Ux designs in Reactjs. We have created the landing page of this website."
    ],
    tags: ["HTML", "CSS", "JavaScript","React"],
    code: "https://github.com/pri65/gpt-3",
    demo: "https://gpt3-gpt.netlify.app/",
    image: two,
  },

  {
    id: 3,
    projectName: "Nike Store",
    // projectHade: "nike-store-commerce",
    projectDesc: [
      "It is a modern e-commerce website. In this project you can also read stories and explore products. And also you can add to cart products, it is fully functional."
    ],
    tags: ["React","Tailwind","ViteJS"],
    code: "https://github.com/pri65/nike_store_commerce",
    demo: "https://nike-store-ecommerce-eight.vercel.app/",
    image: three,
  },
  {
    id: 4,
    projectName: "IMDB Clone",
    // projectHade: "imdb clone",
    projectDesc: [
      "This project is a clone of IMDB website.It contains two pages, the home page, where all the content is categorised and the content page. This website is completely responsive."
    ],
    tags: ["HTML","CSS","JavaScript","React"],
    code: "https://github.com/pri65/imdb-clone",
    demo: "https://nike-store-ecommerce-eight.vercel.app/",
    image: four,
  },
  

];


// "Sign Up | Login | All  Page - with Filter & Sort Functionality",
//       "Search Functionality for Movies and TV Shows",
//       "User Profile (dynamic) User Can update well profile",
//       "Single Video Page (dynamic) along with Add To Watch List Feature",
//       "Buy Plan | Payment Page along with all Functionality",

